import React from 'react';

interface PageLoadingSpinnerProps {
	loadingText?: string;
}

const PageLoadingSpinner: React.FC<PageLoadingSpinnerProps> = ({
	loadingText = 'Loading data... Please Wait...',
}) => {
	return (
		<div
			style={{
				position: 'fixed',
				top: 0,
				left: 0,
				width: '100%',
				height: '100%',
				backgroundColor: 'rgba(255, 255, 255, 0.8)',
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				zIndex: 9999,
				flexDirection: 'column',
			}}>
			<div
				style={{
					position: 'relative',
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
				}}>
				<svg
					width='80'
					height='80'
					viewBox='0 0 80 80'
					style={{
						animation: 'squareRotate 3s linear infinite',
					}}>
					<defs>
						<linearGradient
							id='squareGradient'
							x1='0%'
							y1='0%'
							x2='100%'
							y2='100%'>
							<stop offset='0%' stopColor='#0d6efd' stopOpacity='1' />
							<stop offset='100%' stopColor='#0a58ca' stopOpacity='1' />
						</linearGradient>
					</defs>
					<rect
						x='10'
						y='10'
						width='60'
						height='60'
						rx='8'
						fill='none'
						stroke='url(#squareGradient)'
						strokeWidth='3'
						style={{
							animation: 'squarePulse 2s ease-in-out infinite',
						}}
					/>
					<text
						x='40'
						y='50'
						fontSize='40'
						fontWeight='bold'
						fill='url(#squareGradient)'
						textAnchor='middle'
						dominantBaseline='middle'
						fontFamily='Arial, sans-serif'
						style={{
							animation: 'letterPulse 1.5s ease-in-out infinite',
						}}>
						S
					</text>
				</svg>
				<style>
					{`
						@keyframes squareRotate {
							0% {
								transform: rotate(0deg);
							}
							100% {
								transform: rotate(360deg);
							}
						}
						@keyframes squarePulse {
							0%, 100% {
								stroke-width: 3;
								opacity: 1;
							}
							50% {
								stroke-width: 5;
								opacity: 0.8;
							}
						}
						@keyframes letterPulse {
							0%, 100% {
								transform: scale(1);
								opacity: 1;
							}
							50% {
								transform: scale(1.1);
								opacity: 0.9;
							}
						}
					`}
				</style>
			</div>
			<div
				style={{
					marginTop: '1.5rem',
					fontSize: '1.2rem',
					color: '#333',
					fontWeight: '500',
				}}>
				{loadingText}
			</div>
		</div>
	);
};

export default PageLoadingSpinner;

